export const formatDate = (dateString) => {
  if (!dateString) return "";

  try {
    const [year, month, day] = dateString.split("-");
    return `${day}-${month}-${year}`;
  } catch (error) {
    console.warn("Invalid date format:", dateString);
    return dateString; // Return original if parsing fails
  }
};



export const formatTimeStampDate = (dateString) => {
  if (!dateString) return "N/A";

  const date = new Date(dateString);

  return (
    String(date.getDate()).padStart(2, "0") +
    "-" +
    String(date.getMonth() + 1).padStart(2, "0") +
    "-" +
    date.getFullYear()
  );
};


// utils/dateFormater.js

/**
 * Parse date string into Date object
 * Supports multiple date formats including yyyy-MM-dd, dd-MM-yyyy, etc.
 */
export const parseDate = (dateString) => {
  if (!dateString) return new Date();
  
  // If it's already a Date object, return it
  if (dateString instanceof Date) {
    return dateString;
  }
  
  // Remove any time portion if present
  const dateOnly = dateString.split(' ')[0];
  
  // Try different date formats
  const formats = [
    // yyyy-MM-dd (ISO format)
    /^(\d{4})-(\d{1,2})-(\d{1,2})$/,
    // dd-MM-yyyy
    /^(\d{1,2})-(\d{1,2})-(\d{4})$/,
    // MM/dd/yyyy
    /^(\d{1,2})\/(\d{1,2})\/(\d{4})$/,
    // yyyy/MM/dd
    /^(\d{4})\/(\d{1,2})\/(\d{1,2})$/
  ];
  
  for (const format of formats) {
    const match = dateOnly.match(format);
    if (match) {
      if (format === formats[0]) { // yyyy-MM-dd
        return new Date(parseInt(match[1]), parseInt(match[2]) - 1, parseInt(match[3]));
      } else if (format === formats[1]) { // dd-MM-yyyy
        return new Date(parseInt(match[3]), parseInt(match[2]) - 1, parseInt(match[1]));
      } else if (format === formats[2]) { // MM/dd/yyyy
        return new Date(parseInt(match[3]), parseInt(match[1]) - 1, parseInt(match[2]));
      } else if (format === formats[3]) { // yyyy/MM/dd
        return new Date(parseInt(match[1]), parseInt(match[2]) - 1, parseInt(match[3]));
      }
    }
  }
  
  // Fallback to native Date parsing
  const parsed = new Date(dateString);
  if (!isNaN(parsed.getTime())) {
    return parsed;
  }
  
  // If all parsing fails, return current date
  console.warn(`Unable to parse date: ${dateString}, returning current date`);
  return new Date();
};



export const formatDateObject = (date) => {
  if (!date) return "";

  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();

  return `${day}-${month}-${year}`;
};



export const formatToDDMMYYYY = (dateInput) => {
  if (!dateInput) return null;

  const date = new Date(dateInput);

  if (isNaN(date.getTime())) return null; // invalid date

  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0"); 
  const year = date.getFullYear();

  return `${day}-${month}-${year}`;
};
